import {
  AgreementContratStatus,
  AgreementFulfillmentStatus,
  AgreementInvoicesStatus,
  SelectOptions,
  ShipmentFulfillmentsStatus,
  ShipmentsStatus,
} from '@etoh/database/core';

export const agreementsFulfilledStatusOptions: SelectOptions<AgreementFulfillmentStatus>[] =
  [
    {
      value: 'pendingFulfillment',
      label: 'Pending Fulfillment',
    },
    {
      value: 'partiallyFulfilled',
      label: 'Partially fulfilled',
    },
    {
      value: 'fulfilled',
      label: 'Fulfilled',
    },
  ];

export const agreementsInvoicesStatusOptions: SelectOptions<AgreementInvoicesStatus>[] =
  [
    {
      value: 'invoiced',
      label: 'Invoiced',
    },
    {
      value: 'paid',
      label: 'Paid',
      // Non utilisé
    },
  ];

// finished = fulffilled, paid

export const agreementsContractStatusOptions: SelectOptions<AgreementContratStatus>[] =
  [
    {
      value: 'draft',
      label: 'Draft',
    },
    {
      value: 'toBeSent',
      label: 'To be sent',
    },
    {
      value: 'pendingApproval',
      label: 'Pending Approval',
    },
    {
      value: 'approvedByParties',
      label: 'Approved by parties',
    },
    {
      value: 'canceled',
      label: 'Canceled',
    },
  ];

export const commissionTypeOptions = [
  {
    value: '%',
    label: '%',
  },
  {
    value: 'per UOM',
    label: 'per UOM',
  },
  {
    value: 'flat',
    label: 'flat',
  },
];

export const statusInvoicesOptions = [
  {
    value: 'done',
    label: 'Done',
  },
  {
    value: 'void',
    label: 'Void',
  },
  {
    value: 'pending',
    label: 'Pending',
  },
  {
    value: 'invoiced',
    label: 'Invoiced',
  },
  {
    value: 'paid',
    label: 'Paid',
  },
];

export const statusOptionsShipmentFulfillment: SelectOptions<ShipmentFulfillmentsStatus>[] =
  [
    {
      value: 'ordered',
      label: 'Ordered',
    },
    {
      value: 'fulfilled',
      label: 'Fulfilled',
    },
    {
      value: 'invoiced',
      label: 'Invoiced',
    },
    {
      value: 'cancelled',
      label: 'Cancelled',
    },
  ];

export const dateFormatOptions = [
  {
    value: 'YYYY-MM-DD',
    label: 'US: mm/dd/yyyy',
  },
  {
    value: 'DD-MM-YYYY',
    label: 'French: dd/mm/yyyy',
  },
  {
    value: 'YYYY-MM-dd',
    label: 'International: yy-mm-dd',
  },
  {
    value: 'd M, y',
    label: 'Short Month: d M, y',
  },
  {
    value: 'P',
    label: 'P',
  },
  {
    value: 'PP',
    label: 'PP',
  },
  {
    value: 'PPP',
    label: 'PPP',
  },
];

export const deliveryMethodOptions = [
  {
    label: 'Delivered by Ciatti',
    value: 'deliveredByBroker',
  },
  {
    label: 'Delivered by Carrier',
    value: 'deliveredByCarrier',
  },
  {
    label: 'Picked up by customer',
    value: 'pickedUpByCustomer',
  },
  {
    label: 'Directly sent by supplier',
    value: 'directlySentBySupplier',
  },
];

export const ShipmentsStatusContents: Record<
  ShipmentsStatus,
  { title: string; description: string; inManual: boolean }
> = {
  InfoReceived: {
    title: 'Information Received',
    inManual: true,
    description:
      'Carrier has received request from shipper and is about to pick up the shipment.',
  },
  InTransit: {
    title: 'In Transit',
    inManual: true,
    description:
      'Carrier has accepted or picked up shipment from shipper. The shipment is on the way.',
  },
  OutForDelivery: {
    title: 'Out for Delivery',
    inManual: false,
    description:
      'Carrier is about to deliver the shipment , or it is ready to pickup.',
  },

  AttemptFail: {
    title: 'Failed Attempt',
    inManual: false,
    description:
      'Carrier attempted to deliver but failed, and usually leaves a notice and will try to deliver again.',
  },
  Delivered: {
    title: 'Delivered',
    inManual: true,
    description: 'The shipment was delivered successfully.',
  },
  AvailableForPickup: {
    title: 'Available for Pickup',
    inManual: false,
    description:
      'The package arrived at a pickup point near you and is available for pickup.',
  },
  Exception: {
    title: 'Exception',
    inManual: false,
    description:
      'Custom hold, undelivered, returned shipment to sender or any shipping exceptions.',
  },
  Expired: {
    title: 'Expired',
    inManual: false,
    description:
      'Shipment has no tracking information for 30 days since added.',
  },

  Pending: {
    title: 'Pending',
    inManual: false,
    description:
      'New shipments added that are pending to track, or new shipments without tracking information available yet.',
  },
} as const;

export const shipmentStatusOptions: SelectOptions[] = Object.keys(
  ShipmentsStatusContents
).map((key) => ({
  value: key,
  label: ShipmentsStatusContents[key as ShipmentsStatus].title,
}));

export const getShipmentOptions = (isManual: boolean) => {
  return shipmentStatusOptions.filter((option) =>
    isManual
      ? ShipmentsStatusContents[option.value as ShipmentsStatus].inManual ===
        isManual
      : ShipmentsStatusContents
  );
};

export const sampleShipmentStatusOptions = shipmentStatusOptions;
